import {
  ReadOnly,
  Select,
  useEntityPermission,
  useLocalization,
} from '@ui-framework/index';
import { constantCase } from 'case-anything';
import { observer } from 'mobx-react';
import React, { forwardRef } from 'react';
import { useFormContext } from 'react-hook-form';

const SelectStatic = forwardRef(
  ({ overwriteProps = {}, customConfig, ...props }, ref) => {
    const { options } = customConfig;
    const { getValues } = useFormContext();
    const { formatMessage } = useLocalization();
    const { isHidden, isReadOnly } = useEntityPermission();

    const currentvalue = getValues(props?.field?.name);
    const hasStatus = options.some(obj => 'status' in obj);

    let newOptions = options;
    if (hasStatus) {
      newOptions = options
        .filter(item => {
          return item.status === true || item.value === currentvalue;
        })
        .map(item => {
          let label = item?.label;
          if (item?.label) {
            label = formatMessage({
              id: constantCase(item?.label),
              defaultMessage: item?.label,
            });
          }

          if (item.status === true) {
            return {
              ...item,
              label,
            };
          }
          return {
            ...item,
            label: `${label} (${formatMessage({ id: 'IN_ACTIVE', defaultMessage: 'In-Active' })})`,
          };
        });
    }

    if (isReadOnly(props?.permission, currentvalue)) {
      let label = options.find(i => i.value === currentvalue)?.label;
      if (label) {
        label = formatMessage({
          id: constantCase(label),
          defaultMessage: label,
        });
      }
      return <ReadOnly name={props?.field?.name}>{label}</ReadOnly>;
    }

    if (isHidden(props?.permission)) {
      return (
        <input type="hidden" name={props?.field?.name} value={currentvalue} />
      );
    }

    return (
      <Select
        ref={ref}
        options={newOptions}
        {...props}
        overwriteProps={overwriteProps}
      />
    );
  },
);

export default observer(SelectStatic);
